import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3486cda0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "empty-state" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Illustration = _resolveComponent("Illustration");
    const _component_TitleAndDescription = _resolveComponent("TitleAndDescription");
    const _component_Actions = _resolveComponent("Actions");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Illustration, {
            illustration: _ctx.emptyState.illustration
        }, null, 8, ["illustration"]),
        _createElementVNode("div", null, [
            _createVNode(_component_TitleAndDescription, {
                title: _ctx.emptyState.title,
                description: _ctx.emptyState.description
            }, null, 8, ["title", "description"]),
            _renderSlot(_ctx.$slots, "additionalContent", {}, undefined, true)
        ]),
        (_ctx.emptyState.actions)
            ? (_openBlock(), _createBlock(_component_Actions, {
                key: 0,
                "icon-name": _ctx.emptyState.actions.iconName,
                variant: _ctx.emptyState.actions.variant,
                title: _ctx.emptyState.actions.title,
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
            }, null, 8, ["icon-name", "variant", "title"]))
            : _createCommentVNode("", true)
    ]));
}
